//
//  SDKDocumentationLegacyGroupBehavior.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var DocumentationLegacyGroupBehavior;
(function (DocumentationLegacyGroupBehavior) {
    DocumentationLegacyGroupBehavior["group"] = "Group";
    DocumentationLegacyGroupBehavior["tabs"] = "Tabs";
})(DocumentationLegacyGroupBehavior || (DocumentationLegacyGroupBehavior = {}));
